<template>
    <div>
        <template v-for="section in sections">
            <div :class="{'card mb-3': (!section.base_section || section.base_section == '') || !baseSection}" v-if="(!section.base_section && !baseSection) || (baseSection != null && section.base_section == baseSection)">

                <div class="card-header"  v-if="section.section_name && (!section.base_section || !baseSection)">
                    <strong>{{ section.section_name }}</strong>
                </div>

                <div :class="{'card-body': (!section.base_section || section.base_section == '') || !baseSection}">
                    <template v-for="field in section.fields">
                        <h5 v-if="field.type == 'Heading' && !pdfView">{{ field.label }}</h5>

                        <p v-if="field.type == 'Paragraph' && !pdfView" :class="(field.color ? 'alert alert-'+field.color : null)">{{ field.text }}</p>

                        <div v-if="(field.type != 'Paragraph' && field.type != 'Heading') && (field.parent_field_id == null || (field.parent_field_id != null && field.value))" class="row mb-2">
                            <label :class="`${labelSize}`" class="mb-0">
                                {{ field.label }} <span v-if="field.deleted_at" title="This Custom Field has been deleted, but the value has been retained for historical purposes">(Deleted)</span>:
                            </label>
                            <div :class="`${fieldSize}`">
                                <template v-if="field.type == 'Textarea'">
                                    <div v-html="field.value"></div>
                                </template>
                                <template v-else-if="field.type == 'Employee'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/employees/view/${field.value.EmployeeId}`" title="View Employee">{{ field.value.EmployeeNumber }} - {{ field.value.FirstName }} {{ field.value.LastName }}</router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'Equipment'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/equipment/view/${field.value.equipment_id}`" title="View Equipment">{{ field.value.equipment_type_name }} - {{ field.value.serial_number }}</router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'Jobsite'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/jobsites/view/${field.value.JobsiteId}`" title="View Jobsite">{{ field.value.JobsiteNumber }} - {{ field.value.JobsiteName }}</router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'User'">
                                    <template v-if="field.value != null">
                                        <router-link :to="`/users/view/${field.value.UserId}`" title="View User">{{ field.value.FirstName }} {{ field.value.LastName }}</router-link>
                                    </template>
                                </template>
                                <template v-else-if="field.type == 'File'">
                                    <template v-if="field.value != null">
                                        <a :href="`/files/download/${field.value.file_id}`" v-if="downloadOnly(field.value.file_extension)" target="_blank" title="Download File in a New Tab">{{ field.value.file_name }}</a>
                                        <a :href="`/files/view/${field.value.file_id}`" v-else target="_blank" title="View File in a New Tab">{{ field.value.file_name }}</a>
                                    </template>
                                </template>
                                <template v-else-if="Array.isArray(field.value)" v-for="(val, key) in field.value">
                                    <span v-if="key > 0">, </span>{{ val }}
                                </template>
                                <template v-else>{{ field.value }}</template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            sections: {
                type: Array,
                required: true,
            },

            baseSection: {
                type: String,
                default: null,
            },

            labelSize: {
                type: String,
                default: 'col-md-3 col-12 text-md-right text-muted'
            },

            fieldSize: {
                type: String,
                default: 'col-md-9 col-12',
            },

            pdfView: {
                type: Boolean,
                default: false,
            }
        },

        data: function() {
            return {

            }
        },


        methods: {
            downloadOnly(ext){
                //SEnd it
                return this.$root.filesDownloadOnly.indexOf(ext) === -1 ? false : true;
            },
        },

        mounted() {

        }
    }
</script>